import script from "./SiteFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteFooter.vue?vue&type=script&setup=true&lang=js"

import "./SiteFooter.vue?vue&type=style&index=0&id=185348f6&lang=css"

const __exports__ = script;

export default __exports__